import { Roles } from "../../constants/roles";
import { FormBase } from "../../util/form-base-form";

class UserEditForm extends FormBase {
    public getToggleButton(root: ParentNode = document): HTMLButtonElement | null {
        return this.getButton(root, `[data-role="${Roles.TOGGLE_PROFILE_EDIT}"]`);
    }

    public getDisplayMode(root: ParentNode = document): HTMLElement | null {
        return this.queryElement(root, `[data-role="${Roles.PROFILE_DISPLAY_MODE}"]`, HTMLElement);
    }

    public getEditMode(root: ParentNode = document): HTMLElement | null {
        return this.queryElement(root, `[data-role="${Roles.PROFILE_EDIT_MODE}"]`, HTMLElement);
    }

    public getEditForm(root: ParentNode = document): HTMLFormElement | null {
        return this.getForm(root, `[data-role="${Roles.PROFILE_EDIT_FORM}"]`);
    }

    public getCancelButton(root: ParentNode = document): HTMLButtonElement | null {
        return this.getButton(root, `[data-role="${Roles.CANCEL_PROFILE_EDIT}"]`);
    }

    public getSaveButton(root: ParentNode = document): HTMLButtonElement | null {
        return this.getButton(root, `[data-role="${Roles.SAVE_PROFILE_EDIT}"]`);
    }

    public getAccountInfoSection(root: ParentNode = document): HTMLElement | null {
        return this.queryElement(root, `[data-role="${Roles.ACCOUNT_INFO_SECTION}"]`, HTMLElement);
    }

    public getFirstField(root: ParentNode): HTMLElement | null {
        return this.queryElement(root, "input, select, textarea", HTMLElement);
    }

    public getSubmitButton(root: ParentNode): HTMLButtonElement | HTMLInputElement | null {
        const button = this.queryElement(root, 'button[type="submit"]', HTMLButtonElement);
        if (button) return button;
        return this.queryElement(root, 'input[type="submit"]', HTMLInputElement);
    }

    public getPrefectureOptionsScript(root: ParentNode): HTMLScriptElement | null {
        return this.queryElement(root, `script[data-role="${Roles.USERS_PREFECTURE_OPTIONS}"]`, HTMLScriptElement);
    }

    public getPrefectureModalOverlay(root: ParentNode): HTMLElement | null {
        return this.queryElement(root, `[data-role="${Roles.USERS_PREFECTURE_MODAL_OVERLAY}"]`, HTMLElement);
    }

    public getPrefectureModal(root: ParentNode): HTMLElement | null {
        return this.queryElement(root, `[data-role="${Roles.USERS_PREFECTURE_MODAL}"]`, HTMLElement);
    }

    public getPrefectureModalFilter(root: ParentNode): HTMLInputElement | null {
        return this.getInput(root, `[data-role="${Roles.USERS_PREFECTURE_MODAL_FILTER}"]`);
    }

    public getZipLookupButton(root: ParentNode): HTMLButtonElement | null {
        return this.getButton(root, `[data-role="${Roles.USERS_ZIP_LOOKUP_BTN}"]`);
    }

    public getPrefecturePicker(root: ParentNode): HTMLElement | null {
        return this.queryElement(root, `[data-role="${Roles.USERS_PREFECTURE_PICKER}"]`, HTMLElement);
    }

    public getPrefectureClearButton(root: ParentNode): HTMLButtonElement | null {
        return this.getButton(root, `[data-role="${Roles.USERS_PREFECTURE_CLEAR}"]`);
    }

    public getPrefectureDisplay(root: ParentNode): HTMLElement | null {
        return this.queryElement(root, `[data-role="${Roles.USERS_PREFECTURE_DISPLAY}"]`, HTMLElement);
    }

    public getPrefectureModalClose(root: ParentNode): HTMLElement | null {
        return this.queryElement(root, `[data-role="${Roles.USERS_PREFECTURE_MODAL_CLOSE}"]`, HTMLElement);
    }

    public getPrefectureModalActionButton(root: ParentNode, action: string): HTMLButtonElement | null {
        return this.getButton(root, `[data-role="${Roles.USERS_PREFECTURE_MODAL}"] [data-action="${action}"]`);
    }

    public isPrefectureModalVisible(root: ParentNode): boolean {
        const modal = this.getPrefectureModal(root);
        return modal instanceof HTMLElement && modal.classList.contains("visible");
    }

    public getPrefectureModalList(root: ParentNode): HTMLElement | null {
        return this.queryElement(root, `[data-role="${Roles.USERS_PREFECTURE_MODAL_LIST}"]`, HTMLElement);
    }

    public getPrefectureChoiceInputs(root: ParentNode): HTMLInputElement[] {
        return this.queryElements(root, 'input[name="users-prefecture-modal-choice"]', HTMLInputElement);
    }
}

const userEditForm = new UserEditForm();

export { UserEditForm, userEditForm };
